import { render } from "./BoatsTable.vue?vue&type=template&id=7b8c93b2&scoped=true"
import script from "./BoatsTable.vue?vue&type=script&lang=js"
export * from "./BoatsTable.vue?vue&type=script&lang=js"

import "./BoatsTable.vue?vue&type=style&index=0&id=7b8c93b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8c93b2"]])

export default __exports__